import { EBreakpoints } from '@theme/theme';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    width: 'calc(100vw - 32px)',
    maxWidth: 600,
    margin: '0 auto',
    [theme.breakpoints.up(EBreakpoints.desktop)]: {
      maxWidth: EBreakpoints.desktop,
    },
  },
}));
